const APIUtils = {
  addToCart: async function (item) {
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [item],
        }),
      });

      if (!response.ok) throw new Error("Failed to add to cart");
      return await response.json();
    } catch (error) {
      console.error("Add to cart error:", error);
      throw error;
    }
  },

  updateCartItem: async function (key, quantity) {
    try {
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: key,
          quantity: quantity,
        }),
      });

      if (!response.ok) throw new Error("Failed to update cart");
      return await response.json();
    } catch (error) {
      console.error("Update cart error:", error);
      throw error;
    }
  },

  getCart: async function () {
    try {
      const response = await fetch("/cart.js");
      if (!response.ok) throw new Error("Failed to get cart");
      return await response.json();
    } catch (error) {
      console.error("Get cart error:", error);
      throw error;
    }
  },

  clearCart: async function () {
    try {
      const response = await fetch("/cart/clear.js", {
        method: "POST",
      });
      if (!response.ok) throw new Error("Failed to clear cart");
      return await response.json();
    } catch (error) {
      console.error("Clear cart error:", error);
      throw error;
    }
  },

  getRecommendations: async function (productId, limit = 4) {
    try {
      const response = await fetch(
        `/recommendations/products.json?product_id=${productId}&limit=${limit}`
      );
      if (!response.ok) throw new Error("Failed to get recommendations");
      return await response.json();
    } catch (error) {
      console.error("Get recommendations error:", error);
      throw error;
    }
  },

  searchProducts: async function (query, options = {}) {
    const params = new URLSearchParams({
      q: query,
      type: "product",
      ...options,
    });

    try {
      const response = await fetch(`/search/suggest.json?${params}`);
      if (!response.ok) throw new Error("Failed to search products");
      return await response.json();
    } catch (error) {
      console.error("Search error:", error);
      throw error;
    }
  },

  getProduct: async function (handle) {
    try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) throw new Error("Failed to get product");
      return await response.json();
    } catch (error) {
      console.error("Get product error:", error);
      throw error;
    }
  },

  getCollection: async function (handle) {
    try {
      const response = await fetch(`/collections/${handle}.js`);
      if (!response.ok) throw new Error("Failed to get collection");
      return await response.json();
    } catch (error) {
      console.error("Get collection error:", error);
      throw error;
    }
  },

  updateCartNote: async function (note) {
    try {
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ note }),
      });

      if (!response.ok) throw new Error("Failed to update cart note");
      return await response.json();
    } catch (error) {
      console.error("Update cart note error:", error);
      throw error;
    }
  },

  applyDiscount: async function (code) {
    try {
      const response = await fetch("/discount/" + encodeURIComponent(code));
      if (!response.ok) throw new Error("Failed to apply discount");
      return response;
    } catch (error) {
      console.error("Apply discount error:", error);
      throw error;
    }
  },

  subscribeNewsletter: async function (email) {
    try {
      const response = await fetch("/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          "contact[email]": email,
          "contact[tags]": "newsletter",
        }),
      });

      return response;
    } catch (error) {
      console.error("Newsletter subscription error:", error);
      throw error;
    }
  },

  fetch: async function (url, options = {}) {
    try {
      const response = await fetch(url, {
        headers: {
          "Content-Type": "application/json",
          ...options.headers,
        },
        ...options,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Fetch error:", error);
      throw error;
    }
  },
};

if (typeof module !== "undefined" && module.exports) {
  module.exports = APIUtils;
}
